import React from 'react';
import Icon from './Icon';

type Kind = 'accent' | 'ghost' | 'outline' | 'danger';
type Size = 'xs' | 'sm' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  kind?: Kind;
  size?: Size;
  icon?: string;
  iconRight?: boolean;
  loading?: boolean;
  block?: boolean;
  iconOnly?: boolean;
}

export default function Button({
  kind, size, icon, iconRight, loading, block, iconOnly,
  className = '', children, disabled, type = 'button', ...rest
}: ButtonProps) {
  const cls = [
    't-btn',
    kind && `t-btn--${kind}`,
    size && `t-btn--${size}`,
    block && 't-btn--block',
    (iconOnly || (icon && !children)) && 't-btn--icon',
    className,
  ].filter(Boolean).join(' ');

  const isz = size === 'xs' ? 11 : size === 'sm' ? 12 : 14;

  return (
    <button className={cls} disabled={disabled || loading} type={type} {...rest}>
      {loading
        ? <span className="t-spinner" style={{ width: isz + 4, height: isz + 4 }} />
        : (!iconRight && icon && <Icon name={icon} size={isz} />)
      }
      {children && <span>{children}</span>}
      {!loading && iconRight && icon && <Icon name={icon} size={isz} />}
    </button>
  );
}
